import React from 'react';
import { Helmet } from 'react-helmet-async';

export const SEO = ({ 
  title, 
  description, 
  keywords,
  ogImage = 'https://customer-assets.emergentagent.com/job_dd9d9ce7-fb86-432d-9760-9b14a54b987b/artifacts/aby7covz_IMG_1113.jpeg',
  canonical
}) => {
  const siteUrl = 'https://topdriver.co.uk';
  const fullTitle = title 
    ? (title.includes('Top Driver') ? title : `${title} | Top Driver Driving School`)
    : 'Top Driver Driving School - Professional Driving Lessons in UK';
  const defaultDescription = 'Learn to drive with confidence at Top Driver Driving School. Professional driving instruction from certified experts. Flexible scheduling, modern vehicles, and high pass rates.';
  
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description || defaultDescription} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={canonical || siteUrl} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonical || siteUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description || defaultDescription} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="Top Driver Driving School" />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={canonical || siteUrl} />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={description || defaultDescription} />
      <meta property="twitter:image" content={ogImage} />
      
      {/* Additional Meta Tags */}
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
      <meta name="author" content="Top Driver Driving School" />
    </Helmet>
  );
};
